import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/users/secret/key',
    name: 'secretPOST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
